(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vendor-react"), require("react-widget"));
	else if(typeof define === 'function' && define.amd)
		define("widget-navigation-tool", ["vendor-react", "react-widget"], factory);
	else if(typeof exports === 'object')
		exports["widget-navigation-tool"] = factory(require("vendor-react"), require("react-widget"));
	else
		root["widget-navigation-tool"] = factory(root["vendor-react"], root["react-widget"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_414__, __WEBPACK_EXTERNAL_MODULE_978__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1203);

/***/ }),

/***/ 349:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isBoolean = isBoolean;
	exports.hasNoValue = hasNoValue;
	exports.hasValue = hasValue;
	exports.haveAllValue = haveAllValue;
	exports.isEmpty = isEmpty;
	exports.isLastDigits = isLastDigits;
	exports.isNotEmpty = isNotEmpty;
	exports.isString = isString;
	exports.trimRemoveDuplicateWhitespace = trimRemoveDuplicateWhitespace;
	exports.getBoolean = getBoolean;
	exports.nodeListToArray = nodeListToArray;
	exports.isValidDate = isValidDate;
	exports.isFiniteNumber = isFiniteNumber;
	exports.parseCommaToPointInString = parseCommaToPointInString;
	exports.removeFromStorage = removeFromStorage;
	exports.deleteCookie = deleteCookie;
	exports.getOtpSummary = getOtpSummary;
	exports.saveOtpSummary = saveOtpSummary;
	exports.submitApi = submitApi;
	exports.apiCall = apiCall;
	exports.getJourneyCookie = getJourneyCookie;
	exports.logObj = logObj;
	exports.logAttrObj = logAttrObj;
	exports.transformMapData = transformMapData;
	exports.setDigitalApplicationFormValues = setDigitalApplicationFormValues;
	exports.getDigitalApplicationFormValues = getDigitalApplicationFormValues;
	/* Created by Rowan de Zeeuw on 07/09/2018 */
	
	function isBoolean(value) {
	    return typeof value === 'boolean';
	}
	
	function hasNoValue(value) {
	    return value === null || value === undefined;
	}
	function hasValue(value) {
	    return !hasNoValue(value);
	}
	
	function haveAllValue() {
	    for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
	        values[_key] = arguments[_key];
	    }
	
	    return values.every(function (value) {
	        return hasValue(value);
	    });
	}
	
	function isEmpty(value) {
	    // todo: getting ugly, probably a better way, but we'll get back to this.
	    return hasNoValue(value) || !(value instanceof Date) && typeof value !== 'boolean' && typeof value !== 'number' && Object.keys(value).length === 0;
	}
	
	function isLastDigits(value) {
	    return value.length === 4 || value.length === 10;
	}
	
	function isNotEmpty(value) {
	    return !isEmpty(value);
	}
	
	function isString(str) {
	    return typeof str === 'string' || str instanceof String;
	}
	
	function trimRemoveDuplicateWhitespace(value) {
	    if (isString(value)) {
	        value = value.trim();
	        value = value.replace(/[ \t]+/g, ' ');
	    }
	    return value;
	}
	
	function getBoolean(str) {
	    return (/^true$/i.test(str)
	    );
	}
	
	function nodeListToArray(val) {
	    try {
	        return Array.prototype.slice.call(val);
	    } catch (e) {
	        throw new Error('No array-like list');
	    }
	}
	
	function isValidDate(d) {
	    return d instanceof Date && !isNaN(d);
	}
	
	function isFiniteNumber(value) {
	    return typeof value === 'number' && !isNaN(value) && isFinite(value);
	}
	
	function parseCommaToPointInString(value) {
	    if (!isString(value)) {
	        throw new Error('Not a valid string');
	    }
	
	    return value.replace(/,/g, '.');
	}
	//BEGIN:Coffee Break Methods
	function removeFromStorage() {
	    localStorage.removeItem('custPQToken');
	    localStorage.removeItem('customerDetails');
	    localStorage.removeItem('addressConfig');
	    localStorage.removeItem('otpSummary');
	    localStorage.removeItem('otpDetails');
	    localStorage.removeItem('complianceDetails');
	    localStorage.removeItem('httpResponse');
	    localStorage.removeItem('notHttpResponse');
	    localStorage.removeItem('otpError');
	    localStorage.removeItem('confirmationDetails');
	}
	function deleteCookie(cname) {
	    var d = new Date();
	    d.setTime(d.getTime());
	    var expires = d.toUTCString();
	    return document.cookie = cname + '=;Path=/;expires=' + expires + ';max-age=0';
	}
	function getOtpSummary() {
	    var Helpers = window.App.Utils.Helpers;
	    var Summary = {
	        body: {
	            firstName: "",
	            middleName: "",
	            lastName: "",
	            creditLimit: "",
	            maritalStatus: "",
	            gender: "",
	            taxIdentificationNumber: "",
	            sssOtherID: "",
	            emailAddress: "",
	            sourceOfFunds: "",
	            employerName: "",
	            mobileNumber: "",
	            birthDate: "",
	            employerBusinessNature: "",
	            withEcard: "",
	            referenceNumber: "",
	            selectedCards: [],
	            selectedAddress: [],
	            submitApiPayLoad: {
	                primaryCreditCard: "",
	                secondaryCreditCard: "",
	                primaryCreditCardName: "",
	                secondaryCreditCardName: "",
	                virtualCreditCard: false,
	                billingAddressType: "",
	                emailAddress: "",
	                maritalStatus: "",
	                lastName: "",
	                middleName: "",
	                sourceOfFunds: "",
	                employerName: "",
	                employerBusinessNature: "",
	                employmentCode: "",
	                taxIdentificationNumber: "",
	                sssOtherID: "",
	                termsAndCondition: false
	            }
	
	        }
	    };
	    if (!localStorage.getItem("otpSummary")) {
	        var setToStorage = Helpers.setItemToStorage("otpSummary", JSON.stringify(Summary));
	    }
	    return JSON.parse(Helpers.getItemFromStorage("otpSummary"));
	}
	function saveOtpSummary(fromStorage) {
	    var Helpers = window.App.Utils.Helpers;
	    Helpers.setItemToStorage("otpSummary", JSON.stringify(fromStorage));
	    var itemFromStorage = Helpers.getItemFromStorage("otpSummary");
	    return itemFromStorage;
	}
	function submitApi(url, reqHeaders, data) {
	    return fetch('' + url, {
	        credentials: "include",
	        method: 'POST',
	        headers: reqHeaders,
	        body: JSON.stringify(data)
	    }).then(function (r) {
	        return r.json();
	    }, function (err) {
	        console.error("Error calling web service ", err);
	    });
	}
	function apiCall(url, httpMethod, callHeaders) {
	    return fetch('' + url, {
	        credentials: "include",
	        method: httpMethod,
	        headers: callHeaders
	    }).then(function (r) {
	        return r.json();
	    }, function (err) {
	        console.error("Error calling web service ", err);
	    });
	}
	
	function getJourneyCookie(cname) {
	    var name = cname + "=";
	    var decodedCookie = decodeURIComponent(document.cookie);
	    var ca = decodedCookie.split(";");
	    for (var i = 0; i < ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0) == ' ') {
	            c = c.substring(1);
	        }
	        if (c.indexOf(name) == 0) {
	            return c.substring(name.length, c.length);
	        }
	    }
	    return "";
	}
	function logObj(obj) {
	    if (window.App.Utils.Helpers.isLocalhost()) {
	        console.log(obj);
	    }
	}
	function logAttrObj(str, obj) {
	    if (window.App.Utils.Helpers.isLocalhost()) {
	        console.log(str, obj);
	    }
	}
	//Begin: Json Mapping
	function transformMapData(dataSource, mapping) {
	    var localDS = {};
	
	    var _loop = function _loop(key) {
	        var mapto = mapping[key].mapto;
	        var valueFromSource = eval('dataSource.' + mapto);
	        if (mapping[key].condition !== undefined) {
	            var conditionKey = mapping[key].condition.key;
	            var conditionValue = mapping[key].condition.value;
	            if (Array.isArray(valueFromSource)) {
	                valueFromSource.forEach(function (item, index) {
	                    if (item[conditionKey] === conditionValue) {
	                        localDS[key] = eval('dataSource.' + mapto + '[' + index + ']');
	                    }
	                });
	            }
	        } else {
	            localDS[key] = eval('dataSource.' + mapto);
	        }
	    };
	
	    for (var key in mapping) {
	        _loop(key);
	    }
	    return localDS;
	}
	//End: Json Mapping
	// END: Coffeebreak Methods
	//BEGIN: AMTC Methods
	var digitalApplicationFormValues = {};
	function setDigitalApplicationFormValues(data) {
	    console.log(data);
	    digitalApplicationFormValues = data;
	}
	function getDigitalApplicationFormValues(data) {
	    console.log(digitalApplicationFormValues);
	    return digitalApplicationFormValues;
	}
	//END: AMTC Methods

/***/ }),

/***/ 414:
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_414__;

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vendorReact = __webpack_require__(414);
	
	var _InputWrapper = __webpack_require__(511);
	
	var _InputWrapper2 = _interopRequireDefault(_InputWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global App */
	
	
	/* For standalone usage, outside Form Generation, use the StandaloneHoc for the input fields */
	var AbstractControlledInput = function (_React$PureComponent) {
	    _inherits(AbstractControlledInput, _React$PureComponent);
	
	    function AbstractControlledInput(props) {
	        _classCallCheck(this, AbstractControlledInput);
	
	        var _this = _possibleConstructorReturn(this, (AbstractControlledInput.__proto__ || Object.getPrototypeOf(AbstractControlledInput)).call(this, props));
	
	        _this.onFieldChange = _this.onFieldChange.bind(_this);
	        _this.onFieldBlur = _this.onFieldBlur.bind(_this);
	        _this.onOptionsChange = _this.onOptionsChange.bind(_this);
	        _this.onFieldFocus = _this.onFieldFocus.bind(_this);
	        _this.onPaste = _this.onPaste.bind(_this);
	        return _this;
	    }
	
	    _createClass(AbstractControlledInput, [{
	        key: 'onOptionsChange',
	        value: function onOptionsChange(event) {
	            var value = this.props.options[parseInt(event.target.value)].value;
	            this.props.onChange(value);
	        }
	    }, {
	        key: 'onFieldChange',
	        value: function onFieldChange(event) {
	            var value = this.getParsedInputValue(event);
	            if (value !== event.target.value) {
	                event.target.value = value;
	            }
	            this.props.onChange && this.props.onChange(value);
	        }
	    }, {
	        key: 'onFieldBlur',
	        value: function onFieldBlur(event) {
	            if (!this.props.onBlur) {
	                return;
	            }
	
	            var orgValue = event.target.value;
	            var value = this.getParsedInputValue(event);
	            value = this.transformValue(value);
	            // Todo: quirky hack. If user fills in a value that will be the as the prop value AFTER transform
	            // the input doesn't renew, because the KEY is the same.
	            // e.g. first letter capitilaize:
	            // Ana-Banana => Ana-banana
	            // Ana-Banana => Ana-Banana in input, Ana-banana in model.
	            if (this.props.value !== value || value !== orgValue) {
	                event.target.value = value;
	            }
	            this.props.onBlur(value);
	        }
	    }, {
	        key: 'onFieldFocus',
	        value: function onFieldFocus(event) {
	            this.props.onFocus && this.props.onFocus();
	        }
	
	        // Overridden only in the DateInput class
	
	    }, {
	        key: 'onPaste',
	        value: function onPaste(event) {
	            if (this.props.disabledPaste) {
	                event.preventDefault();
	            }
	        }
	    }, {
	        key: 'transformValue',
	        value: function transformValue(eventValue) {
	            var value = eventValue;
	            value = App.Utils.Object.trimRemoveDuplicateWhitespace(value);
	            var transformers = this.props.transformers;
	
	            if (App.Utils.Object.isNotEmpty(transformers)) {
	                value = transformers.reduce(function (result, transformer) {
	                    return transformer(result);
	                }, value);
	            }
	            return value;
	        }
	    }, {
	        key: 'getValue',
	        value: function getValue(fallbackValue) {
	            var value = this.props.value;
	
	            var actualValue = App.Utils.Object.hasValue(value) ? value : fallbackValue || '';
	            return this.formatter(actualValue);
	        }
	    }, {
	        key: 'formatter',
	        value: function formatter(value) {
	            return value;
	        }
	    }, {
	        key: 'getParsedInputValue',
	        value: function getParsedInputValue(event) {
	            return event.target.value;
	        }
	    }, {
	        key: 'getInputWrapperProps',
	        value: function getInputWrapperProps() {
	            var _props = this.props,
	                dirty = _props.dirty,
	                focus = _props.focus,
	                label = _props.label,
	                validation = _props.validation,
	                onChange = _props.onChange,
	                onBlur = _props.onBlur,
	                onClear = _props.onClear,
	                value = _props.value,
	                clearOption = _props.clearOption,
	                required = _props.required,
	                additionalWrapperGroupClass = _props.additionalWrapperGroupClass,
	                helpText = _props.helpText;
	
	            return {
	                label: label,
	                validation: validation,
	                dirty: dirty,
	                focus: focus,
	                onChange: onChange,
	                onBlur: onBlur,
	                onClear: onClear,
	                value: value,
	                clearOption: clearOption,
	                required: required,
	                additionalWrapperGroupClass: additionalWrapperGroupClass,
	                helpText: helpText
	            };
	        }
	    }, {
	        key: 'renderInput',
	        value: function renderInput() {
	            throw new Error('Abstract class, implement this method');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _vendorReact.React.createElement(
	                _InputWrapper2.default,
	                this.getInputWrapperProps(),
	                this.renderInput()
	            );
	        }
	    }]);
	
	    return AbstractControlledInput;
	}(_vendorReact.React.PureComponent);
	
	exports.default = AbstractControlledInput;

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vendorReact = __webpack_require__(414);
	
	var _index = __webpack_require__(512);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global App */
	
	
	var isNotEmpty = App.Utils.Object.isNotEmpty;
	var isString = App.Utils.Object.isString;
	
	var InputWrapper = function (_React$PureComponent) {
	    _inherits(InputWrapper, _React$PureComponent);
	
	    function InputWrapper(props) {
	        _classCallCheck(this, InputWrapper);
	
	        var _this = _possibleConstructorReturn(this, (InputWrapper.__proto__ || Object.getPrototypeOf(InputWrapper)).call(this, props));
	
	        _this.state = {
	            openHelpText: false
	        };
	        _this.toggleTooltip = _this.toggleTooltip.bind(_this);
	        _this.clear = _this.clear.bind(_this);
	        return _this;
	    }
	
	    _createClass(InputWrapper, [{
	        key: 'getValidationStateClass',
	        value: function getValidationStateClass() {
	            var validation = this.props.validation;
	
	
	            if (isString(validation)) {
	                return 'invalid';
	            } else if (validation === true) {
	                return 'valid';
	            }
	            return null;
	        }
	    }, {
	        key: 'getClasses',
	        value: function getClasses() {
	            var _props = this.props,
	                dirty = _props.dirty,
	                focus = _props.focus;
	
	            var cls = ['input-wrapper'];
	            var validationStatus = this.getValidationStateClass();
	            validationStatus && cls.push(validationStatus);
	            cls.push(dirty ? 'dirty' : 'pristine');
	            focus && cls.push('focus');
	            return cls.join(' ');
	        }
	    }, {
	        key: 'renderValidationMessage',
	        value: function renderValidationMessage() {
	            var validation = this.props.validation;
	
	
	            if (isString(validation)) {
	                return _vendorReact.React.createElement(
	                    'div',
	                    { className: 'input-wrapper__error-message' },
	                    validation
	                );
	            }
	            return null;
	        }
	    }, {
	        key: 'clear',
	        value: function clear() {
	            var _props2 = this.props,
	                onChange = _props2.onChange,
	                onBlur = _props2.onBlur,
	                onClear = _props2.onClear;
	
	
	            if (onClear) {
	                onClear();
	            } else if (onChange) {
	                onChange('');
	            } else if (onBlur) {
	                onBlur('');
	            }
	        }
	    }, {
	        key: 'renderClearIcon',
	        value: function renderClearIcon() {
	            var _props3 = this.props,
	                value = _props3.value,
	                clearOption = _props3.clearOption;
	
	            if (clearOption && isNotEmpty(value)) {
	                return _vendorReact.React.createElement('div', { onClick: this.clear, className: 'input-group-text input-wrapper__clear-icon' });
	            }
	            return null;
	        }
	    }, {
	        key: 'toggleTooltip',
	        value: function toggleTooltip() {
	            this.setState(function (prevState) {
	                return {
	                    openHelpText: !prevState.openHelpText
	                };
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props4 = this.props,
	                label = _props4.label,
	                children = _props4.children,
	                required = _props4.required,
	                additionalWrapperGroupClass = _props4.additionalWrapperGroupClass,
	                helpText = _props4.helpText,
	                emailLabel = _props4.emailLabel;
	            var openHelpText = this.state.openHelpText;
	
	
	            return _vendorReact.React.createElement(
	                'div',
	                { className: this.getClasses() },
	                label && _vendorReact.React.createElement(_index2.default, {
	                    className: 'input-wrapper__label',
	                    label: label,
	                    required: required,
	                    onTooltipClick: helpText ? this.toggleTooltip : null,
	                    emailLabel: emailLabel
	                }),
	                helpText && openHelpText && _vendorReact.React.createElement('div', {
	                    className: 'input-wrapper__help-text',
	                    dangerouslySetInnerHTML: { __html: helpText }
	                }),
	                _vendorReact.React.createElement(
	                    'div',
	                    { className: 'input-group ' + (additionalWrapperGroupClass || '') },
	                    children,
	                    this.renderClearIcon()
	                ),
	                this.renderValidationMessage()
	            );
	        }
	    }]);
	
	    return InputWrapper;
	}(_vendorReact.React.PureComponent);
	
	exports.default = InputWrapper;

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vendorReact = __webpack_require__(414);
	
	function Label(props) {
	    var _getTextAndInfo = getTextAndInfo(),
	        text = _getTextAndInfo.text,
	        info = _getTextAndInfo.info;
	
	    var className = props.className,
	        onTooltipClick = props.onTooltipClick,
	        required = props.required,
	        emailLabel = props.emailLabel;
	
	
	    function getTextAndInfo() {
	        var label = props.label;
	
	        if (label instanceof Object) {
	            return {
	                text: label.text,
	                info: label.info
	            };
	        } else {
	            return { text: label };
	        }
	    }
	
	    return _vendorReact.React.createElement(
	        "label",
	        { className: className, "data-emaillabel": emailLabel },
	        _vendorReact.React.createElement(
	            "span",
	            { className: "label__text" },
	            text
	        ),
	        info && _vendorReact.React.createElement("span", { className: "label__info", title: info }),
	        !required && _vendorReact.React.createElement(
	            "span",
	            { className: "label__optional" },
	            "Optional"
	        ),
	        onTooltipClick && _vendorReact.React.createElement("span", { className: "label__tooltip", onClick: onTooltipClick })
	    );
	}
	
	exports.default = Label;

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.createKey = createKey;
	
	var _object = __webpack_require__(349);
	
	function createKey(index, anything) {
	    return index.toString() + '_' + ((0, _object.hasValue)(anything) ? anything.toString() : '');
	}

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _vendorReact = __webpack_require__(414);
	
	var _index = __webpack_require__(510);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _keyCreator = __webpack_require__(516);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global App */
	
	
	var hasNoValue = App.Utils.Object.hasNoValue;
	var hasValue = App.Utils.Object.hasValue;
	
	var DEFAULT_PLACEHOLDER_LABEL = 'Please select one';
	var FORM_APP_PAGE = 'form-application-page';
	
	var SelectInput = function (_AbstractControlledIn) {
	    _inherits(SelectInput, _AbstractControlledIn);
	
	    function SelectInput(props) {
	        _classCallCheck(this, SelectInput);
	
	        var _this = _possibleConstructorReturn(this, (SelectInput.__proto__ || Object.getPrototypeOf(SelectInput)).call(this, props));
	
	        _this.closeSelect = _this.closeSelect.bind(_this);
	        _this.selectClickHandler = _this.selectClickHandler.bind(_this);
	        _this.onChange = _this.onChange.bind(_this);
	        _this.onBlur = _this.onBlur.bind(_this);
	
	        _this.documentClickHandlerRemover = null;
	        _this.listRef = null;
	        _this.selectRef = null;
	        _this.placeholder = _this.props.placeholder || DEFAULT_PLACEHOLDER_LABEL;
	        _this.state = {
	            open: false
	        };
	        return _this;
	    }
	
	    _createClass(SelectInput, [{
	        key: 'closeSelect',
	        value: function closeSelect() {
	            this.setState({
	                open: false
	            });
	            this.removeDocumentHandler();
	        }
	    }, {
	        key: 'onBlur',
	        value: function onBlur(event) {
	            this.props.onBlur && this.props.onBlur(event);
	        }
	    }, {
	        key: 'removeDocumentHandler',
	        value: function removeDocumentHandler() {
	            this.documentClickHandlerRemover && this.documentClickHandlerRemover();
	            this.documentClickHandlerRemover = null;
	        }
	    }, {
	        key: 'selectClickHandler',
	        value: function selectClickHandler(event) {
	            var _this2 = this;
	
	            event.stopPropagation();
	            if (this.state.open) {
	                this.closeSelect();
	                return;
	            }
	
	            document.addEventListener('click', this.closeSelect);
	            this.documentClickHandlerRemover = function () {
	                return document.removeEventListener('click', _this2.closeSelect);
	            };
	
	            this.setState({
	                open: true
	            }, function () {
	                _this2.scrollToLabel();
	            });
	        }
	    }, {
	        key: 'scrollToLabel',
	        value: function scrollToLabel() {
	            //Work around, improvement accepted.
	            if (window.innerHeight - this.listRef.getBoundingClientRect().bottom < 0) {
	                this.selectRef.parentElement.parentElement.scrollIntoView();
	                var isFormApp = document.body.classList.contains(FORM_APP_PAGE);
	                if (!isFormApp) {
	                    window.scrollBy(0, -App.Utils.Helpers.getNavigationHeight());
	                }
	            }
	        }
	    }, {
	        key: 'isOptionSelected',
	        value: function isOptionSelected(option) {
	            var value = this.getValue();
	            return hasNoValue(value) && hasNoValue(option) || hasValue(option) && value === option.value;
	        }
	    }, {
	        key: 'getOptionClassName',
	        value: function getOptionClassName(option) {
	            return this.isOptionSelected(option) ? 'selected' : '';
	        }
	    }, {
	        key: 'selectItem',
	        value: function selectItem(idx, event) {
	            event.stopPropagation();
	            this.closeSelect();
	            this.onChange({ target: { selectedIndex: idx } });
	        }
	    }, {
	        key: 'onChange',
	        value: function onChange(event) {
	            var idx = event.target.selectedIndex;
	            this.props.onChange(idx > 0 ? this.props.options[idx - 1].value : null);
	        }
	    }, {
	        key: 'getSelectedOption',
	        value: function getSelectedOption() {
	            var value = this.getValue();
	            return this.props.options.find(function (option) {
	                return option.value === value;
	            }) || {
	                label: this.placeholder,
	                value: null
	            };
	        }
	    }, {
	        key: 'renderInput',
	        value: function renderInput() {
	            var _this3 = this;
	
	            var _props = this.props,
	                name = _props.name,
	                options = _props.options,
	                required = _props.required;
	            var open = this.state.open;
	
	
	            var selectedOption = this.getSelectedOption();
	
	            return _vendorReact.React.createElement(
	                'div',
	                {
	                    ref: function ref(_ref2) {
	                        return _this3.selectRef = _ref2;
	                    },
	                    onBlur: this.onBlur,
	                    tabIndex: '0',
	                    className: 'select-input ' + (open ? 'open' : '')
	                },
	                _vendorReact.React.createElement(
	                    'select',
	                    {
	                        className: 'select-input__select-input',
	                        name: name,
	                        onChange: this.onChange,
	                        placeholder: this.placeholder,
	                        value: this.getValue(),
	                        required: required
	                    },
	                    _vendorReact.React.createElement(
	                        'option',
	                        { value: '' },
	                        this.placeholder
	                    ),
	                    options.map(function (option, idx) {
	                        return _vendorReact.React.createElement(
	                            'option',
	                            { key: (0, _keyCreator.createKey)(idx, option.value), value: option.value },
	                            option.label
	                        );
	                    })
	                ),
	                _vendorReact.React.createElement(
	                    'div',
	                    {
	                        className: 'form-control select-input__fake-input ' + (selectedOption.value === null ? 'placeholder' : ''),
	                        onClick: this.selectClickHandler
	                    },
	                    _vendorReact.React.createElement(
	                        'div',
	                        { className: 'select-input__fake-input-label-wrapper' },
	                        _vendorReact.React.createElement(
	                            'div',
	                            { className: 'select-input__fake-input-label' },
	                            selectedOption.label
	                        )
	                    )
	                ),
	                _vendorReact.React.createElement(
	                    'div',
	                    { ref: function ref(_ref) {
	                            return _this3.listRef = _ref;
	                        }, className: 'select-input__dropdown' },
	                    _vendorReact.React.createElement(
	                        'ul',
	                        null,
	                        options.map(function (option, idx) {
	                            return _vendorReact.React.createElement(
	                                'li',
	                                {
	                                    key: (0, _keyCreator.createKey)(idx, option.value),
	                                    onClick: _this3.selectItem.bind(_this3, idx + 1),
	                                    className: _this3.getOptionClassName(option)
	                                },
	                                option.label
	                            );
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SelectInput;
	}(_index2.default);
	
	exports.default = SelectInput;

/***/ }),

/***/ 978:
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_978__;

/***/ }),

/***/ 1203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactWidget = __webpack_require__(978);
	
	var _reactWidget2 = _interopRequireDefault(_reactWidget);
	
	var _vendorReact = __webpack_require__(414);
	
	var _SelectInput = __webpack_require__(524);
	
	var _SelectInput2 = _interopRequireDefault(_SelectInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Widget = function (_ReactWidget) {
	    _inherits(Widget, _ReactWidget);
	
	    function Widget(props) {
	        _classCallCheck(this, Widget);
	
	        var _this = _possibleConstructorReturn(this, (Widget.__proto__ || Object.getPrototypeOf(Widget)).call(this, props));
	
	        var options = _this.getStringPreference("options") ? JSON.parse(_this.getStringPreference("options")) : [];
	        // ADD VALUE PROPERTY SAME AS URL
	        options.forEach(function (element) {
	            element.value = element.url;
	        });
	
	        var selectedElement = _this.getSelectedElement(options);
	        _this.state = {
	            url: selectedElement && selectedElement.url,
	            options: options,
	            selectedTitle: selectedElement && selectedElement.label
	        };
	
	        _this.default_url = _this.getStringPreference("defaultMicrositeUrl");
	        _this.placeholder = " ";
	
	        return _this;
	    }
	
	    _createClass(Widget, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.sendLoadedDom();
	        }
	    }, {
	        key: 'sendLoadedDom',
	        value: function sendLoadedDom() {
	            // to trigger loaded dom
	            var loadedNavtool = new CustomEvent('loadedNavtool', {});
	            window.dispatchEvent(loadedNavtool);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var inserted = false;
	            var localThis = this;
	
	            App.PubSub.publish('recalculateTopNavPadding');
	            this.sendLoadedDom();
	
	            function displaySideNavTool() {
	                if ($(".top-navigation__menu-toggle").css("display") !== 'none') {
	                    $(".navtool-container").css("display", "none");
	                    var title = localThis.state.selectedTitle;
	                    var options = localThis.state.options;
	                    if (!inserted) {
	                        createLinksForMobileViewsSimple(options, title);
	                        inserted = true;
	                    } else {
	                        $("#navtool-in-mobile").css("display", "initial");
	                    }
	                } else {
	                    $(".navtool-container").css("display", "flex");
	                    if (inserted) {
	                        $("#navtool-in-mobile").css("display", "none");
	                    }
	                }
	            }
	
	            // CODE FOR MOBILE THAT HAS DROPDOWN BUT NOT CLICKABLE LINK
	            function createLinksForMobileView(options, title) {
	                var items = "";
	                options.forEach(function (option, index) {
	                    var headerNodes = '';
	                    option.headers.forEach(function (header) {
	                        headerNodes += '\n                    <a\n                        href="' + header.url + '"\n                        class="top-navigation__level-3__section-link" target="_blank"\n                    >\n                        ' + header.label + '\n                    </a>\n                ';
	                    });
	                    items += '\n                    <li class="has-children top-navigation__level-2__item" id="link-li-id-' + index + '">\n                        <a\n                            href="' + option.url + '"\n                            style="white-space: nowrap;"\n                            class="top-navigation__level-2__link js-level2-item ext_link"\n                        >\n                            ' + option.label + '\n                        </a>\n                        <div class="top-navigation__level-3">\n                            <div class="top-navigation__container">\n                                ' + headerNodes + '\n                            </div>\n                        </div>\n                    </li>\n                ';
	                });
	                var htmlNode = '\n                <li class="top-navigation__level-1__item has-children for-dropdown" id="navtool-in-mobile">\n                    <a class="top-navigation__level-1__link ext_link">You are in&nbsp;<span>' + title + '</span></a>\n                    <div class="top-navigation__level-1__children_mobile js-mobile-children">\n                        <div class="top-navigation__level-2">\n                            <ul class="top-navigation__level-2__list">\n                                ' + items + '\n                            </ul>\n                        </div>\n                    </div>\n                </li>';
	
	                $(".top-navigation__level-1__list").prepend(htmlNode);
	                $("#navtool-in-mobile").click(function () {
	                    $("#navtool-in-mobile").toggleClass("active");
	                });
	                options.forEach(function (option, index) {
	                    var id = '#link-li-id-' + index;
	                    $(id).click(function (event) {
	                        event.preventDefault();
	                        event.stopPropagation();
	                        $(id).toggleClass('open');
	                    });
	                });
	            }
	
	            // CODE FOR MOBILE THAT HAS DROPDOWN BUT NOT CLICKABLE LINK
	            function createLinksForMobileViewsSimple(options, title) {
	                if (!window.location.href.includes(localThis.default_url)) {
	                    var items = "";
	                    options.forEach(function (option, index) {
	                        items += '<li class="top-navigation__level-2__item" id="link-li-id-' + index + '">\n                        <a href="' + option.url + '" style="white-space: nowrap;" class="top-navigation__level-2__link js-level2-item ext_link">' + option.label + '</a>    \n                    </li>';
	                    });
	
	                    var htmlNode = '\n                <li class="top-navigation__level-1__item has-children" id="navtool-in-mobile">\n                    <a href="http://" class="top-navigation__level-1__link ext_link" target="_blank" data-toggle="" data-target="">You are in <span>' + title + '</span></a>\n                    <div class="top-navigation__level-1__children_mobile js-mobile-children">\n                        <div class="top-navigation__level-2">\n                            <ul class="top-navigation__level-2__list">\n                                ' + items + '\n                            </ul>\n                        </div>\n                    </div>\n                </li>';
	
	                    $(".top-navigation__level-1__list").prepend(htmlNode);
	                    $("#navtool-in-mobile").click(function () {
	                        event.preventDefault();
	                        event.stopPropagation();
	                        $("#navtool-in-mobile").toggleClass("active");
	                    });
	                    options.forEach(function (option, index) {
	                        var id = '#link-li-id-' + index;
	                        $(id).click(function () {
	                            window.open(option.url, "_self");
	                        });
	                    });
	                }
	            }
	
	            // TO HIDE AND SHOW THE NAVTOOL UPON SCROLL
	            window.onscroll = function () {
	                scrollFunction();
	            };
	            function scrollFunction() {
	                var scrollYPosition = document.body.scrollTop || document.documentElement.scrollTop;
	                var clientWidth = document.body.clientWidth || document.documentElement.clientWidth;
	
	                if (scrollYPosition > 50 && $(".top-navigation__menu-toggle").css("display") === 'none') {
	                    $(".navtool-container").css("display", "none");
	                } else if (scrollYPosition < 10 && $(".top-navigation__menu-toggle").css("display") === 'none') {
	                    $(".navtool-container").css("display", "flex");
	                }
	            }
	
	            displaySideNavTool();
	            window.addEventListener('resize', function () {
	                displaySideNavTool();
	            });
	        }
	
	        // FIND THE SELECTED JSON
	
	    }, {
	        key: 'getSelectedElement',
	        value: function getSelectedElement(options) {
	            var _this2 = this;
	
	            var currentURL = window.location.href;
	            var selectedElement = options.find(this.checkingOfURL(currentURL));
	
	            if (selectedElement) {
	                return selectedElement;
	            } else {
	                return selectedElement = options.find(function (element) {
	                    return element.headers.find(_this2.checkingOfURL(currentURL));
	                });
	            }
	        }
	
	        // currying
	        // TO GET THE VALID URL
	
	    }, {
	        key: 'checkingOfURL',
	        value: function checkingOfURL(currentURL) {
	            return function (element) {
	                // checking of the URL in the JSON
	                var urlCheck = currentURL.includes(element.url);
	                if (urlCheck) {
	                    if (element.url == "") {
	                        return false;
	                    } else {
	                        return urlCheck;
	                    }
	                } else if (element.friendlyURL == "") {
	                    // checking of the Friendly URL in the JSON
	                    return false;
	                } else {
	                    return currentURL.includes(element.friendlyURL);
	                }
	            };
	        }
	
	        // ON BUTTON CLICK TO CHANGE THE CURRENT SITE
	
	    }, {
	        key: 'onChangeValue',
	        value: function onChangeValue(url) {
	            //this.setState({url: url});
	            window.open(url, "_self");
	        }
	
	        // SHOWING THE RIGHT SIDE HEADERS
	
	    }, {
	        key: 'showHeaders',
	        value: function showHeaders() {
	            var _this3 = this;
	
	            var headerContent = this.state.options.find(function (element) {
	                return element.url === _this3.state.url;
	            });
	
	            if (headerContent) {
	                return headerContent.headers.map(function (home, index) {
	                    return _vendorReact.React.createElement(
	                        'a',
	                        { key: index, className: 'navtool-a-link', href: home.url },
	                        home.label
	                    );
	                });
	            }
	            return null;
	        }
	
	        // TO SHOW IF THE 'YOU ARE IN' AT THE RIGHT SIDE
	
	    }, {
	        key: 'showSelect',
	        value: function showSelect() {
	            if (window.location.href.includes(this.default_url)) {
	                return null;
	            }
	            return [_vendorReact.React.createElement(
	                'div',
	                { key: '0', className: 'navtool-label' },
	                'You are in'
	            ), _vendorReact.React.createElement(
	                'div',
	                { key: '1', className: 'navtool-select' },
	                _vendorReact.React.createElement(_SelectInput2.default, {
	                    options: this.state.options,
	                    placeholder: this.placeholder,
	                    value: this.state.url,
	                    onChange: this.onChangeValue.bind(this)
	                })
	            )];
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.state.url === undefined || this.state.options === []) {
	                return "";
	            }
	            return _vendorReact.React.createElement(
	                'div',
	                { className: 'navtool-container wide-container' },
	                _vendorReact.React.createElement(
	                    'div',
	                    { className: 'navtool-left-div' },
	                    this.showSelect()
	                ),
	                _vendorReact.React.createElement(
	                    'div',
	                    { className: 'navtool-header' },
	                    this.showHeaders()
	                )
	            );
	        }
	    }]);
	
	    return Widget;
	}(_reactWidget2.default);
	
	exports.default = Widget;

/***/ })

/******/ })
});
;


// WEBPACK FOOTER //
// widget-navigation-tool/scripts/widget-navigation-tool.js